module.exports = __webpack_public_path__ + "static/media/026.631030cb.jpg";